import styled from 'styled-components';

export const StyledIllustration = styled.div`
  position: relative;
  z-index: 10;
  width: 424px;
  height: 520px;
  filter: var(--color-filter) brightness(1.1);
  transition: filter var(--theme-transition-duration);
  display: none;

  @media screen and (min-width: 768px) {
    width: 424px;
    height: 520px;
    display: block;
  }

  @media screen and (min-width: 1024px) {
    width: 424px;
    height: 520px;
  }
`;

export const StyledCloudLeft = styled.div`
  aspect-ratio: 157 / 55;
  width: 33%;
  position: absolute;
  z-index: 5;
  top: 4.7%;
  left: 19%;
`;

export const StyledCloudCentral = styled.div`
  aspect-ratio: 33 / 14;
  width: 26%;
  position: absolute;
  z-index: 30;
  top: 16%;
  left: 43%;
`;

export const StyledCloudRight = styled.div`
  aspect-ratio: 23 / 10;
  width: 20%;
  position: absolute;
  z-index: 20;
  top: 15%;
  left: 57%;
`;

export const StyledBalloon = styled.div`
  width: 7.5%;
  height: 9.6%;
  position: absolute;
  z-index: 50;
  top: 19.2%;
  left: 11.8%;
`;

export const StyledIsland = styled.div`
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 30px);
  /* filter: var(--color-filter); */
	animation: floating 6s ease-in-out infinite;

  & > img {
    object-fit: contain;
    object-position: center;
  }

  @keyframes floating {
    0% {
      transform: translatey(0px);
    }
    50% {
      transform: translatey(30px);
    }
    100% {
      transform: translatey(0px);
    }
  }
`;